import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextLinkUnderlineStyle } from '../../TextLink/TextLink';
import { TextWeight, Theme } from '../../types/enums';
import { IconStyle } from '../../Icons';
import AlertMessage, { AlertMessagePropsTypes } from '../../AlertMessage/AlertMessage';
import { AlertContainerProps } from './types/propTypes';
import { AlertContainerType } from './types/enum';
import styles from './AlertContainer.module.scss';

export const AlertContainer: FC<AlertContainerProps> = (props: AlertContainerProps) => {
  const { onAlertClick, alertType = AlertContainerType.WARNING } = props;

  const { t } = useTranslation();
  const labels = {
    alert: `${t('admin.pageHeader.alert')}`,
    error: `${t('admin.pageHeader.error')}`,
    info: `${t('admin.pageHeader.info')}`,
    action: `${t('admin.pageHeader.action')}`,
    checkDetails: `${t('admin.pageHeader.checkAlertDetails')}`,
  };

  const alertContent = () => {
    let alertProps: AlertMessagePropsTypes = {
      content: { heading: labels.alert },
      theme: Theme.WARNING,
      textWeight: TextWeight.BOLD,
      textLink: { text: labels.checkDetails, underline: TextLinkUnderlineStyle.FIXED, onClick: onAlertClick },
    };

    switch (alertType) {
      case AlertContainerType.WARNING:
        alertProps = { ...alertProps, content: { heading: labels.alert }, theme: Theme.WARNING };
        break;
      case AlertContainerType.ERROR:
        alertProps = { ...alertProps, content: { heading: labels.error }, theme: Theme.ERROR };
        break;
      case AlertContainerType.ACTION:
        alertProps = { ...alertProps, content: { heading: labels.action }, theme: Theme.ACTION };
        break;
      case AlertContainerType.INFO:
        alertProps = {
          ...alertProps,
          content: { heading: labels.info },
          theme: Theme.BLACK,
          icon: 'circle-exclamation',
          iconStyle: IconStyle.SOLID,
        };
        break;
      //no default
    }
    return alertProps;
  };

  return <AlertMessage {...alertContent()} className={styles['alert-border']} />;
};

export default AlertContainer;
export { AlertContainerType };
export type { AlertContainerProps };
